import { useQuery } from '@tanstack/react-query';
import { templatesDetailService } from '../services/templatesDetail.service';

export function useTemplatesDetail(id: string) {
  const query = useQuery({
    queryKey: ['settings', 'templates', 'detail', id],
    queryFn: () => templatesDetailService.getTemplate(id),
    enabled: !!id,
  });

  return {
    template: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
